<button class="primary-button w-100 border-0" [disabled]="disabled()">
    <span>{{ text() }}</span>
</button>